<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <div class="imgs"><img src="@/assets/logox.png" alt="氢能" /></div>
        <div class="name">
          <div>浙江省氢能装备制造业创新中心</div>
          <div>
            Zhejiang Hydrogen Energy Equipment Manufacturing Innovation Center
          </div>
        </div>
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0,0)"
          :text-color="navBackground"
          :active-text-color="navBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1">首页</el-menu-item>
          <el-submenu index="5">
            <template slot="title">组建方式</template>
            <el-menu-item index="5-1" class="menu_item">公司联盟</el-menu-item>
            <el-menu-item index="5-2" class="menu_item"
              >研究院（牵头）</el-menu-item
            >
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">谋篇布局</template>
            <el-menu-item index="2-1" class="menu_item">研发攻关</el-menu-item>
            <el-menu-item index="2-2" class="menu_item">中试检测</el-menu-item>
            <el-menu-item index="2-3" class="menu_item"
              >标准化体系</el-menu-item
            >
            <el-menu-item index="2-4" class="menu_item">人才交流</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">新闻动态</template>
            <el-menu-item index="3-1" class="menu_item">通知公告</el-menu-item>
            <el-menu-item index="3-2" class="menu_item">中心新闻</el-menu-item>
            <el-menu-item index="3-3" class="menu_item">行业资讯</el-menu-item>
            <el-menu-item index="3-4" class="menu_item">会议活动</el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">创新成果</template>
            <el-menu-item index="6-1" class="menu_item">成果转化</el-menu-item>
            <el-menu-item index="6-2" class="menu_item">拓展合作</el-menu-item>
            <el-menu-item index="6-3" class="menu_item">行业标准</el-menu-item>
            <el-menu-item index="6-4" class="menu_item">企业专利</el-menu-item>
            <el-menu-item index="6-5" class="menu_item">企业论文</el-menu-item>
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">大数据中心</template>
            <el-menu-item index="7-1" class="menu_item"
              >可视化大屏</el-menu-item
            >
            <el-menu-item index="7-2" class="menu_item">绿色低碳</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title"> <div class="about"><div>了解我们</div><br/><div class="en">About Us</div></div> </template>
            <el-menu-item index="4-1" class="menu_item">公司介绍</el-menu-item>
            <el-menu-item index="4-2" class="menu_item">联系公司</el-menu-item>
            <el-menu-item index="4-3" class="menu_item">联系我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "0",
      navBackground: "#fff",
    };
  },
  props: {
    selectIndex: {
      type: String,
      default: "0",
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex;
    window.onscroll = () => {
      if (document.documentElement.scrollTop > 390) {
        this.navBackground = "#000";
      } else {
        this.navBackground = "#fff";
      }
    };
  },
  methods: {
    changeCurrentPage(index) {
      this.activeIndex = index;
      switch (index) {
        case "1":
          this.$router.push("/home").catch((v) => {});
          break;
        case "2-1":
          this.$router.push("/plan/1").catch((v) => {});
          break;
        case "2-2":
          this.$router.push("/plan/2").catch((v) => {});
          break;
        case "2-3":
          this.$router.push("/plan/3").catch((v) => {});
          break;
        case "2-4":
          this.$router.push("/plan/4").catch((v) => {});
          break;
        case "3-1":
          this.$router.push("/news/1").catch((v) => {});
          break;
        case "3-2":
          this.$router.push("/news/2").catch((v) => {});
          break;
        case "3-3":
          this.$router.push("/news/3").catch((v) => {});
          break;
        case "3-4":
          this.$router.push("/news/4").catch((v) => {});
          break;
        case "4-1":
          this.$router.push("/fivenav/1").catch((v) => {});
          break;
        case "4-2":
          this.$router.push("/fivenav/2").catch((v) => {});
          break;
        case "4-3":
          this.$router.push("/fivenav/3").catch((v) => {});
          break;
        case "5-1":
          this.$router.push("/combination/1").catch((v) => {});
          break;
        case "5-2":
          this.$router.push("/combination/2").catch((v) => {});
          break;
        case "6-1":
          this.$router.push("/achievement").catch((v) => {});
          break;
        case "6-2":
          this.$router.push("/expand").catch((v) => {});
          break;
        case "6-3":
          this.$router.push("/knowledge/1").catch((v) => {});
          break;
        case "6-4":
          this.$router.push("/knowledge/2").catch((v) => {});
          break;
        case "6-5":
          this.$router.push("/knowledge/3").catch((v) => {});
          break;
        case "7-2":
          this.$router.push("/green").catch((v) => {});
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.abuout {
  line-height: 28px;
  font-size: 15px;
}
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      width: 40%;
      display: flex;
      align-items: center;
      height: 100%;
      .name {
        color: #fff;
        font-size: 15px;
      }
      .imgs {
        display: flex;
        align-items: center;
        width: 100px;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
    .navbar_right {
      width: 60%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }
    }
  }
}
::v-deep .el-submenu__title {
  font-size: 18px !important;
}
::v-deep .el-menu-item {
  font-size: 18px;
}
>>> .el-menu-item,
.menu_item {
  color: #000 !important;
  font-size: 18px;
}
.about{
  display: inline-block;
  line-height: 10px;
  .en{
    text-align: center;
    font-size: 12px;
  }
}
</style>
<style >
.el-menu--popup {
  background-color: #fff !important; /* 使用 !important 确保优先级 */
}
</style>